import React from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextBox from './Components/TextBox.jsx';
import CheckBox from './Components/CheckBox.jsx';
import { UserProvider } from './../Providers/UserProvider';
import { BaseProvider } from './../Providers/BaseProvider'
import { Routes } from './../Core/Constants'

const RegistrationForm = ({ onSuccess }) => {
	var T = window.Texts.registration;
	return (

		<Formik
			initialValues={{
				email: '',
				password: '',
				confirmPassword: '',
				dontSendNews: false,
				notes: ''
			}}
			validationSchema={Yup.object({
				email: Yup.string()
					.email('Nesprávná emailová adresa')
					.required('Required'),
				password: Yup.string()
					.min(8, 'Minimální délka hesla je 8 znaků')
					.required('Required'),
				/*	notes: Yup.string()
						.max(250, 'Maximální délka poznámky je 250 znaků'),*/
				confirmPassword: Yup.string()
					.oneOf(
						[Yup.ref('password')],
						'Hesla nesouhlasí',
					)
					.required('Required')
			})}
			onSubmit={(values, actions) => {
				values.gdprConsent = true; //explicit accept by registration
				values.sendNews = !values.dontSendNews; //now is disagree checkbox
				UserProvider.register(values, (data) => {
					actions.setSubmitting(false);
					onSuccess();
				},
					(error) => {
						BaseProvider.applyServerFormValidation(actions, error);
					}
				);
			}} >
			{(props) => (
				<Form className="reg-form-validate" >
					<div>
						{props.errors.general ?
							<div>
								<p className="missing-entry">
									<strong>{props.errors.general}</strong>
								</p>
							</div> : null}
						<div className="box form-box ">
							<div className="prow form">
								<div className="pcol form-group input-5">
									<TextBox label={T.email} name="email" required="true" type="text" />
								</div>
							</div>
							<div className="prow form">
								<div className="pcol form-group input-5">
									<TextBox label={T.password} name="password" required="true" type="password" />
								</div>
								<div className="pcol form-group input-5">
									<TextBox label={T.passwordConfirm} name="confirmPassword" required=" true" type="password" />
								</div>
							</div>
							<div className="form-group">
								<label>{T.gdprText}</label>
								<ul className="Registration-option">
									<li>
										<CheckBox className="" name="dontSendNews">
											<>
												{T.dontSendNews}
											</>
										</CheckBox>
									</li>
								</ul>
							</div>
							<input type="hidden" name="notes" id="notes" value="" />

							<button type="submit" className="btn btn50 iconed icon-continue"><span>{T.doRegister}</span></button>
						</div>
					</div>
				</Form>
			)}
		</Formik>
	);
}
export default RegistrationForm;